import { render, staticRenderFns } from "./ProductsApp.vue?vue&type=template&id=a0751126&scoped=true&"
import script from "./ProductsApp.vue?vue&type=script&lang=js&"
export * from "./ProductsApp.vue?vue&type=script&lang=js&"
import style0 from "./ProductsApp.vue?vue&type=style&index=0&id=a0751126&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0751126",
  null
  
)

export default component.exports